export default __webpack_public_path__ + "static/media/wallpaper_bg1.2320dddf.png";